export const GET_CANDIDATE_MAPPING = "GET_CANDIDATE_MAPPING";
export const GET_CANDIDATE_MAPPING_SUCCESS = "GET_CANDIDATE_MAPPING_SUCCESS";
export const GET_CANDIDATE_MAPPING_FAILURE = "GET_CANDIDATE_MAPPING_FAILURE";

export const POST_CANDIDATE_MAPPING = "POST_CANDIDATE_MAPPING";
export const POST_CANDIDATE_MAPPING_SUCCESS = "POST_CANDIDATE_MAPPING_SUCCESS";
export const POST_CANDIDATE_MAPPING_FAILURE = "POST_CANDIDATE_MAPPING_FAILURE";




